import React from 'react'
import { useEffectOnce } from 'react-use'
import { Button, Text } from '@stone-payments/jade'

import defaultStrings from '../../strings'

export type SurveysInAppFeedbackProps = {
  title?: string
  description?: string
  actionButtonText?: string
  isLoading?: boolean
  action: () => void
} & SurveysInAppFeedbackPropsEvents

// Callbacks needed usually for analytics events
export type SurveysInAppFeedbackPropsEvents = {
  onMount?: () => void
}

export const SurveysInAppFeedbackCard: React.FC<SurveysInAppFeedbackProps & { fullscreen?: boolean }> = React.memo(
  ({ title, description, action, onMount, actionButtonText, isLoading }) => {
    useEffectOnce(() => {
      if (typeof onMount === 'function') {
        onMount()
      }
    })

    return (
      <section data-testid="feedback-card" className="flex flex-col h-full w-full gap-jade-250">
        <div className="flex flex-col text-center gap-jade-100">
          <Text color="high" variant="heading-small">
            {title || defaultStrings.feedback.title}
          </Text>
          <Text color="medium">{description || defaultStrings.feedback.description}</Text>
        </div>

        <div className="w-full justify-center">
          <Button
            data-testid="feedback-action"
            loading={isLoading === true}
            size="large"
            style={{ width: '100%' }}
            onClick={() => {
              if (typeof action !== 'function') {
                throw new Error('invalid survey feedback action function ')
              }
              action()
            }}
          >
            {actionButtonText || defaultStrings.feedback.actionButtonText}
          </Button>
        </div>
      </section>
    )
  }
)
